// assets
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';

// icons
const icons = {
  dashboard: DashboardOutlinedIcon,
  users: GroupOutlinedIcon,
  subscription: CreditCardOutlinedIcon,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'YaYfi operations',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/',
      icon: icons.dashboard,
      breadcrumbs: false
    },
    {
      id: 'users',
      title: 'Clinic users',
      type: 'item',
      url: '/users',
      icon: icons.users,
      breadcrumbs: false
    },
    {
      id: 'subscription',
      title: 'Plans & subscriptions',
      type: 'item',
      url: '/subscriptions',
      icon: icons.subscription,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
